import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string()
    .required('Organization Name is required')
    .min(3, 'Organization Name must be at least 3 characters'),
  address1: Yup.string().required('Address is required'),
  contactNo: Yup.string()
    .required('Contact Number is required')
    .matches(/^[0-9]{10}$/, 'Contact Number must be a valid 10-digit number'),
  orgEmail: Yup.string()
    .email('Invalid email address')
    .required('Organization Email is required'),
  username: Yup.string()
    .required('Username is required'),
  website: Yup.string()
    .url('Invalid URL format'),
    
  tagLine: Yup.string()
    .max(150, 'Tagline must not exceed 150 characters'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});
